<template>
  <div id="app">
    <div><router-view /></div>
  </div>
</template>

<script>
import { checkVersion } from '@/utils/versionCheck';
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}

export default {
  name: 'App', 
  created() {
    const isAuthenticated = localStorage.getItem('auth_token');
    if (isAuthenticated) {
      console.log('已登录');
    }
  },
  mounted() {
    checkVersion();
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 0;
}

body {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
}
</style>
